module.exports = __webpack_public_path__ + "img/asset-access.29427623.svg";